import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateProductQuantity, removeProductFromCart, setDeliveryMethod, syncCartWithServer } from '../redux/reducers/cartSlice';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import MenuPrincipal from '../components/menuPrincipal';
import '../style/cartPage.css'
import { useNavigate } from 'react-router-dom';
import Rodape from "../components/rodape";
import WhatsApp from "../components/whatsApp";

const CartPage = () => {
    const dispatch = useDispatch();
    const { products, totalAmount } = useSelector((state) => state.cart);
    const [pickupInStore, setPickupInStore] = useState(false);
    const navigate = useNavigate();
    console.log(useSelector((state) => state.cart), 'useSelector((state) => state.cart)')
    const BASE_URL = process.env.REACT_APP_BASE_URL
    const handleQuantityChange = (productId, quantity) => {
        dispatch(updateProductQuantity({ productId, quantity }));
    };

    const handleRemoveProduct = (productId) => {
        dispatch(removeProductFromCart(productId));
    };

    const handleSetDeliveryMethod = (method) => {
        dispatch(setDeliveryMethod(method));
    };


    const handleFinalizePurchase = () => {
        navigate('/checkout');
    };

    useEffect(() => {
        dispatch(syncCartWithServer());
    }, [dispatch])

    return (
        <div>
            <MenuPrincipal />
            <div className={products.length === 0 ? 'section-spacing-5' : 'section-spacing-4'}>

                <Row>
                    <h2 className="text-center mb-4"> <i class="fa-solid fa-cart-shopping" style={{ color: '#E79800' }}></i> Seu Carrinho</h2>
                    <Col xs={12} md={12} lg={6}>
                        {products.length === 0 ? (
                            <p className="text-center cart-vazio">Seu carrinho está vazio.</p>
                        ) : (
                            <div>
                                {products.map((product) => (
                                    <Row key={product.id} className="mb-4 card-item">
                                        <Col xs={12} md={6} lg={6} className='mb-4'>
                                            <img
                                                alt={product.name}
                                                className="cart-product-image"
                                                src={
                                                    product?.images[0]?.url
                                                        ? product.images[0].url.startsWith("data:image") // Verifica se é base64
                                                            ? product.images[0].url // Base64
                                                            : `${BASE_URL}storage/${product.images[0].url}` // Caminho no servidor
                                                        : "default-image-path" // Caminho para uma imagem padrão
                                                }
                                            />
                                        </Col>
                                        <Col xs={12} md={6} lg={6} className="cart-mobile">
                                            <h4>{product.name}</h4>
                                            <span className="cart-product-price">
                                                <p>{Number(product.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                            </span>
                                            <div className="quantity-control">
                                                <Form.Label>Quantidade:</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    min="1"
                                                    value={product.quantity}
                                                    onChange={(e) =>
                                                        handleQuantityChange(product.id, parseInt(e.target.value))
                                                    }
                                                />
                                            </div>
                                            <Button
                                                variant="outline-danger"
                                                className="mt-3"
                                                onClick={() => handleRemoveProduct(product.id)}
                                            >
                                                Remover
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        )}
                    </Col>
                    <Col xs={12} md={12} lg={6}>
                        {/* Opção de Retirada na Loja */}
                        <div className="opcao-pag">
                            <h4><i class="fa-solid fa-truck"></i> Formas de entrega</h4>
                            <Form.Check
                                type="checkbox"
                                label="Retirada na loja"
                                checked={pickupInStore}
                                onChange={(e) => setPickupInStore(e.target.checked)}
                            />
                        </div>
                    </Col>
                </Row>
                {products.length > 0 && (
                    <div>
                        <div className="cart-summary-2">
                            <i class="fa-solid fa-money-bill-wave icone-total"></i>
                            <p><span className='total'>Total: </span>{totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        </div>

                        {/* Botão de Finalizar Compra */}
                        <div className="finalize-purchase text-center">
                            <Button variant="primary" onClick={handleFinalizePurchase} style={{ margin: '0px 0px 20px 0px' }} disabled={!pickupInStore}>
                                Finalizar Compra
                            </Button>
                        </div>
                    </div>
                )}

            </div>
            <Rodape />
             <WhatsApp classe={'whatsapp-componente-flutuante outra-posicao'}/>
        </div>
    );
};

export default CartPage;
